{
  "login": {
    "title": "Войдите в свой аккаунт",
    "emailLabel": "Адрес электронной почты",
    "emailPlaceholder": "вы@example.com",
    "passwordLabel": "Пароль",
    "passwordPlaceholder": "••••••••",
    "forgotPassword": "Забыли пароль?",
    "submit": "Войти",
    "submitting": "Вход…",
    "errors": {
      "invalidCredentials": "Неверные данные. Проверьте адрес электронной почты и пароль.",
      "accountInactive": "Ваш аккаунт неактивен. Обратитесь к администратору.",
      "unexpected": "Произошла непредвиденная ошибка. Пожалуйста, попробуйте снова."
    }
  },
  "forgotPassword": {
    "title": "Сброс пароля",
    "successTitle": "Проверьте почту",
    "description": "Введите адрес электронной почты, и мы отправим вам ссылку для сброса пароля.",
    "emailLabel": "Адрес электронной почты",
    "submit": "Отправить ссылку",
    "submitting": "Отправка…",
    "backToSignIn": "Назад к входу",
    "genericError": "Что-то пошло не так. Пожалуйста, попробуйте снова.",
    "successMessage": "Если аккаунт с адресом {{email}} существует, вы получите ссылку для сброса пароля в ближайшее время."
  },
  "resetPassword": {
    "title": "Установите новый пароль",
    "newPasswordLabel": "Новый пароль",
    "confirmPasswordLabel": "Подтвердите новый пароль",
    "submit": "Сбросить пароль",
    "submitting": "Сброс…",
    "errors": {
      "passwordMismatch": "Пароли не совпадают.",
      "invalidLink": "Недействительная или устаревшая ссылка. Пожалуйста, запросите новую.",
      "expiredLink": "Эта ссылка для сброса недействительна или устарела.",
      "requestNewLink": "Запросить новую ссылку"
    },
    "success": "Пароль успешно сброшен. Пожалуйста, войдите."
  },
  "changePassword": {
    "title": "Изменить пароль",
    "currentPasswordLabel": "Текущий пароль",
    "newPasswordLabel": "Новый пароль",
    "confirmPasswordLabel": "Подтвердите новый пароль",
    "newPasswordPlaceholder": "Минимум 8 символов",
    "confirmPasswordPlaceholder": "Минимум 8 символов",
    "submit": "Изменить пароль",
    "submitting": "Сохранение…",
    "errors": {
      "currentPasswordIncorrect": "Текущий пароль неверен.",
      "tooShort": "Новый пароль должен содержать не менее 8 символов.",
      "passwordMismatch": "Пароли не совпадают.",
      "genericFailed": "Не удалось изменить пароль. Пожалуйста, попробуйте снова."
    },
    "success": "Пароль успешно изменён."
  }
}
